export default __webpack_public_path__ + "static/yeti-431a34948cc7a27584cea6a4aabf9bde1134ec656a077c710eff01d0a52b743b.png";